import { Button, Grid2 } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { useAppContext } from "AppContext";
import { CommonPagination, GKTable } from "components";
import dayjs from "dayjs";
import { useState } from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "utils/axiosInstance";
import { extraColumnsField } from "utils/helpers";
import HistoricalModal from "./HistoricalModal";

function HistoricalPrices() {
  const { id } = useParams();

  const {
    state: { commonFilter, currentUser },
  } = useAppContext();

  const isDisabled = currentUser?.phone === "9911223344";

  const [isOpenModal, setIsOpenModal] = useState(false);

  const [type, setType] = useState("");

  const requestBody = {
    requireTotalCount: true,
    take: commonFilter?.historicalPrice?.take,
    skip: commonFilter?.historicalPrice?.skip,
    sort: JSON.stringify(
      commonFilter?.historicalPrice?.sortModel?.map((data: any) => {
        return {
          selector: data.field,
          desc: data.sort !== "asc",
        };
      })
    ),
    search: commonFilter?.historicalPrice?.search || "",
  };

  const {
    data: historicalPricesData,
    isFetching: historicalPriceFetching,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["ADMIN_INSTRUMENT_HMP", requestBody],
    queryFn: async () =>
      axiosInstance.get(`/admin-instrument-hmp/${id}/`, {
        params: requestBody,
      }),
  });

  const cusPagination = () => {
    return (
      <CommonPagination
        name="historicalPrice"
        totalCount={historicalPricesData?.data.totalCount || 0}
      />
    );
  };

  const historicalPriceColumns: GridColDef[] = [
    {
      ...extraColumnsField("Timestamp", "timestamp", 0, 1),
      valueGetter: (row) => dayjs(row?.row?.timestamp).format("DD/MM/YYYY"),
    },
    {
      ...extraColumnsField("Adjusted Price", "adjustedPrice", 0, 1),
      type: "number",
      valueGetter: (row) => parseFloat(row?.row?.adjustedPrice).toFixed(2),
    },
    {
      ...extraColumnsField("Unadjusted Price", "unadjustedPrice", 0, 1),
      type: "number",
      valueGetter: (row) => parseFloat(row?.row?.unadjustedPrice).toFixed(2),
    },
  ];

  return (
    <Grid2 container spacing={1}>
      <Grid2 size={12} display={"flex"} justifyContent={"flex-end"}>
        <Button
          variant="outlined"
          size="small"
          disabled={isDisabled}
          onClick={() => {
            setType("HMP");
            setIsOpenModal(true);
          }}
        >
          Add HMP
        </Button>{" "}
        &nbsp;
        <Button
          variant="outlined"
          size="small"
          disabled={isDisabled}
          onClick={() => {
            setType("CMP");
            setIsOpenModal(true);
          }}
        >
          Update CMP
        </Button>
      </Grid2>
      <Grid2 size={12}>
        <GKTable
          name="historicalPrice"
          loading={historicalPriceFetching}
          columns={historicalPriceColumns}
          rows={historicalPricesData?.data?.data || []}
          showFilters={false}
          CustomPagination={!isLoading && cusPagination}
        />
      </Grid2>

      {isOpenModal && (
        <HistoricalModal
          open={isOpenModal}
          setOpen={setIsOpenModal}
          type={type}
          refetch={refetch}
        />
      )}
    </Grid2>
  );
}

export default HistoricalPrices;
